<template>
    <div>
        <table :key="'create' + key" class="table table-sm border-0">
            <thead>
                <tr>
                    <th style="width: 22%">Prénom</th>
                    <th style="width: 22%">Nom</th>
                    <th style="width: 22%">Fonction</th>
                    <th style="width: 22%">Email</th>
                    <th>Téléphone</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <b-form-input
                            v-model="form.firstname"
                            size="sm"
                            type="text"
                        />
                    </td>
                    <td>
                        <b-form-input
                            v-model="form.surname"
                            size="sm"
                            type="text"
                        />
                    </td>
                    <td>
                        <b-form-input
                            v-model="form.title"
                            size="sm"
                            type="text"
                        />
                    </td>
                    <td>
                        <b-form-input
                            v-model="form.email"
                            size="sm"
                            type="email"
                        />
                    </td>
                    <td>
                        <b-form-input
                            v-model="form.mobile_number"
                            size="sm"
                            :formatter="phoneFormatter"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
        <b-button variant="success" size="sm" @click="storeContact">
            Enregistrer
        </b-button>
        <b-button variant="secondary" size="sm" @click="hideForm">
            Annuler
        </b-button>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Formatter from '../../../../common/mixins/Formatter.vue'

export default {
    name: 'ContactCreate',

    mixins: [Formatter],

    props: {
        company: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            form: {
                firstname: '',
                surname: '',
                title: '',
                email: '',
                mobile_number: '',
            },
        }
    },

    computed: {
        ...mapState({
            key: (state) => state.browsing.key,
        }),
    },

    methods: {
        async storeContact() {
            try {
                this.form.client_id = this.company.id
                await axios.post('/clientContacts', this.form)
                this.$emit('contact-has-been-created')
                this.hideForm()
            } catch (error) {
                console.log(error)
            }
        },

        hideForm() {
            this.$store.commit('legalVM/RESET_STATUS')
        },
    },
}
</script>

<style scoped></style>
